var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c("h1", { staticClass: "content-title" }, [
              _vm._v(_vm._s(this.title)),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }